import classNames from "classnames";
import React from "react";

import LoadingSpinner from "../../../common/LoadingSpinner";
import { IProduct } from "../../../models/catalogue.interfaces";
import { ConfiguratorOptions } from "../elements/ConfiguratorOptions";
import { getDefaultConfiguratorOptionSet } from "../utils";

interface IProps {
    // Basic Data
    rootProduct: IProduct | null;

    // TODO(i18n): Ensure configType values are not user-facing. If they are displayed in UI, they need i18n.
    // Misc UI options
    configType: string;
}

interface IState {}

// TODO(ssr, LEVEL 2 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 2/10 due to 78 LOC, simple presentational component with minimal logic, basic option selector rendering, and straightforward product data access.
export class MiniConfigurator extends React.Component<IProps, IState> {
    private buildOptionSelectors() {
        const optionSet = getDefaultConfiguratorOptionSet();
        return (
            <ConfiguratorOptions
                disableQuantity={true}
                style={"mini"}
                optionSet={optionSet}
            />
        );
    }

    private buildConfiguratorContent() {
        if (!this.props.rootProduct) {
            return <LoadingSpinner />;
        }

        return <div>{this.buildOptionSelectors()}</div>;
    }

    private getRootClassNames() {
        return classNames({
            "configurator--mini": true,
            [`${this.props.configType}__configurator--mini`]: true,
        });
    }

    private getProductUPC() {
        return this.props.rootProduct && this.props.rootProduct.upc
            ? this.props.rootProduct.upc
            : "";
    }

    private getChildrenUPCs() {
        const children =
            this.props.rootProduct && this.props.rootProduct.children
                ? this.props.rootProduct.children
                : [];
        return children.map((c) => {
            return c.upc;
        });
    }

    render() {
        const configuratorClass = this.getRootClassNames();
        const productUPC = this.getProductUPC();
        const childrenUPCJSON = JSON.stringify(this.getChildrenUPCs());
        return (
            <div
                className={configuratorClass}
                data-mpn={productUPC}
                data-children-mpns={childrenUPCJSON}
            >
                {this.buildConfiguratorContent()}
            </div>
        );
    }
}
